import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import { BrokerAccountInputModel } from "../models/BrokerAccountInputModel";
import BrokerAccountModel from "../models/BrokerAccountModel";
import BrokerAccountQueryModel from "../models/BrokerAccountQueryModel";
import ContactQueryModel from "../models/BrokerAccountQueryModel";

export interface SearchBrokerAccountParam {
    pageSize: number,
    query: BrokerAccountQueryModel
}

export interface GetBrokerAccountByIdParam {
    id: string,
}

export interface DeleteBrokerAccountByIdParam {
    id: string,
}

const BrokerAccountApi = {
    Search(param: SearchBrokerAccountParam) {
        return Api.post<SearchBrokerAccountParam, BaseResponse<BrokerAccountModel[]>>("/api/brokeraccount/Search", param);
    },
    Save(param: BrokerAccountInputModel) {
        return Api.post<BrokerAccountInputModel, BaseResponse<BrokerAccountModel>>("/api/brokeraccount/Save", param);
    },
    GetById(param: GetBrokerAccountByIdParam) {
        return Api.get<GetBrokerAccountByIdParam, BaseResponse<BrokerAccountModel>>("/api/brokeraccount/GetById", param);
    },
    Delete(param: DeleteBrokerAccountByIdParam) {
        return Api.post<DeleteBrokerAccountByIdParam, BaseResponse<BrokerAccountModel>>("/api/brokeraccount/Delete", param);
    },
};
export default BrokerAccountApi;